// extracted by mini-css-extract-plugin
export var discard = "_2g-4";
export var muiTooltipTooltip = "_2g-6";
export var notificationBar = "_2g-3";
export var notificationContainer = "_2g-2";
export var saveButtonHoverSlotWrapper = "_2g-5";
export var show = "_2g-1";
export var spacer = "_2g-0";